import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const defaultOptions = ({
  baseURL: `${BACKEND_URL}/api/`,
  timeout: 300000, //tiempo de espera
  headers: {
    'Content-Type': 'application/json',  
  },
});
export const axiosInstance = axios.create(defaultOptions);

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error en la solicitud:', error);
    return Promise.reject(error);
  }
);

